import { get, patch, post, destroy } from './httpClient'
export const apiAddUser = (body) => post('/user/getuser', body)
export const apiCreateUserMenu = (object) => post('/user/adduser', object)
export const apiAllUser = (params) => get('/user/getuser', params)
export const getRoles = () => get('/role')
export const apiSearch = (object) => get('/user/getuser', object)
export const updateUser = (body, id) => patch(`/user/updateuser/${id}`, body)
export const deleteUsers = (ids) => destroy('/user/delete', { user_id: ids })
